export const errorHandler = error => {
    console.log(error)
    //if(error.response && error.response.status !== httpStatus.OK) window.location.href = '/'
    return Promise.reject(error)
}